import React from 'react'

import Vertical from '../layouts/Vertical.jsx'
import Grid from '../components/Grid.jsx'
import Card from '../components/Card.jsx'
import LoadingState from '../components/LoadingState.jsx'

import { getIncomeByAge, getIncomeByGender } from '_services/insights-v2.js'
import useRequest from '../hooks/useRequest.js'

import BarStackedCartesianHOC from '../charts/BarStackedCartesianHOC.jsx'
import {
  AGES_MAP,
  GENDERS_MAP,
  INCOMES_MAP,
  formatIncomeBy,
} from '../../charts/helpers/formatters.js'

const COLORS_GENDER = ['#7D69B5', '#250F65']
const COLORS_AGE = ['#060773', '#2B4C93', '#5399B7', '#5CD6CB', '#52BB8E', '#2C9344', '#0A7104']

const IncomeByAgeAndGender = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const { title, description, section_1, section_2 } = props.data

  const { data: ageData, loading: ageLoading } = useRequest(
    getIncomeByAge,
    { audienceId, timeRange: null },
    true
  )
  const ageFormatted = formatIncomeBy(ageData, AGES_MAP, INCOMES_MAP)

  const { data: genderData, loading: genderLoading } = useRequest(
    getIncomeByGender,
    { audienceId, timeRange: null },
    true
  )
  const genderFormatted = formatIncomeBy(genderData, INCOMES_MAP, GENDERS_MAP)

  return (
    <Vertical
      title={title}
      description={description}
      page={props.index + 1}
      content={() => (
        <Grid
          direction="horizontal"
          gap={48}
          items={[
            {
              component: (
                <Card title={section_1.title} description={section_1.subtitle} showBorder={true}>
                  <Choose>
                    <When condition={ageLoading}>
                      <LoadingState />
                    </When>
                    <Otherwise>
                      <BarStackedCartesianHOC
                        data={ageFormatted}
                        colors={COLORS_AGE}
                        mode="stacked"
                        labels={{ y: 'Users %', x: 'Age' }}
                      />
                    </Otherwise>
                  </Choose>
                </Card>
              ),
              size: 0.5,
            },
            {
              component: (
                <Card title={section_2.title} description={section_2.subtitle} showBorder={true}>
                  <Choose>
                    <When condition={genderLoading}>
                      <LoadingState />
                    </When>
                    <Otherwise>
                      <BarStackedCartesianHOC
                        data={genderFormatted}
                        colors={COLORS_GENDER}
                        mode="stacked"
                        labels={{ y: 'Users %', x: 'Income' }}
                      />
                    </Otherwise>
                  </Choose>
                </Card>
              ),
              size: 0.5,
            },
          ]}
        />
      )}
    />
  )
}

export default IncomeByAgeAndGender
